module.exports = __webpack_public_path__ + "img/whitedownarrow.c5d0969c.svg";